import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, Row, UiButton, UiText} from '~/components/elements';
import {METHOD_KEYS} from '~/constants/medical-questionnaires';
import {PH_CHECKOUT_METHOD_KEY, POP_UP_PH_CHECKOUT_KEYS, QUESTIONS_PARAMS} from '~/constants/popup';
import {RootState} from '~/redux/root-reducer';
import {PopupLayout} from './components';
import {addQuestionnaire} from '~/redux/questionnaires/thunk';
import {requestOK} from '~/utils/thunk-api';
import {unwrapResult} from '@reduxjs/toolkit';
import {AppDispatch} from '~/redux/root-store';
import {useRequestState} from '~/hooks';

export const PopupSorry = () => {
  const dispatch: AppDispatch = useDispatch();
  const answer = useSelector((state: RootState) => state.questionnaires.collectData);
  const {loading} = useRequestState(addQuestionnaire);

  const onClickSubmit = async () => {
    const resAction = await dispatch(
      addQuestionnaire({
        data: {
          data: {
            ...answer,
            USED_BIRTH_CONTROL: {
              data: {
                selectedOption: '',
                brandUsed: '',
                issues: '',
              },
              index: 'SCREEN 1',
              questions: QUESTIONS_PARAMS.USED_BIRTH_CONTROL,
            },
            CURRENTLY_MEDICATIONS: {
              data: {
                selectedOption: '',
                treatments: '',
              },
              index: 'SCREEN 2',
              questions: QUESTIONS_PARAMS.CURRENTLY_MEDICATIONS,
            },
            MORE_INFORMATION: {
              data: {
                breastFeedingOptions: '',
                smokeOptions: '',
                anyDiseaseHistoryOptions: '',
              },
              index: 'SCREEN 3',
              questions: QUESTIONS_PARAMS.MORE_INFORMATION,
            },
            MEDICAL_HISTORY: {
              data: {
                selectedOption: '',
                tellUsMore: '',
              },
              index: 'SCREEN 4',
              questions: QUESTIONS_PARAMS.MEDICAL_HISTORY,
            },
          },
          methodKey: PH_CHECKOUT_METHOD_KEY,
          wpUserId: answer?.PROFILE?.data?.user?.wpUserId,
        },
      }),
    );
    if (requestOK(resAction, addQuestionnaire)) {
      const result = unwrapResult(resAction);
      if (window.parent) {
        window.parent.postMessage(
          {
            type: METHOD_KEYS.PH_CHECKOUT,
            isClose: true,
            data: result,
          },
          '*',
        );
      }
    }
  };

  return (
    <Col justifyContent="space-between" style={{height: '100%'}}>
      <PopupLayout>
        <UiText style={{fontSize: '20px', fontWeight: 700, lineHeight: '30px'}} textAlign="center" mb={4}>
          We&apos;re sorry
        </UiText>
        <UiText style={{textAlign: 'center', fontWeight: 400, fontSize: '16px', lineHeight: '30px'}} mb={4}>
          We are not permitted to provide contraception or emergency contraception to those below 18, cisgender men or
          anyone obtaining medication on behalf of someone else.
        </UiText>
        <UiText style={{textAlign: 'center', fontWeight: 400, fontSize: '16px', lineHeight: '30px'}}>
          If your partner, friend or relative needs to use our services, please have them create an account or reach out
          to us.
        </UiText>
      </PopupLayout>
      <Row alignItems="center" justifyContent="center" mb={5}>
        <UiButton
          disabled={loading}
          isLoading={loading}
          bg={'#456762'}
          onClick={onClickSubmit}
          variant="solid"
          style={{borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
        >
          Exit
        </UiButton>
      </Row>
    </Col>
  );
};
